import FacilityInfo from "@/views/reporting/CCDDActivities/FacilityInfo.vue";
import Materials from "@/views/reporting/CCDDActivities/Materials.vue";

export default {
    FacilityInfo,
    Materials
}